export const GAME_REFERENCE_DATE = '2026-09-19';
export const SAVE_SCHEMA_VERSION = 19;
export const REAL_MS_PER_GAME_HOUR_AT_X1 = 1000;
export const MAX_HISTORY_POINTS_PER_INDICATOR = 1800;
export const MAX_JOURNAL_ENTRIES = 3000;
export const MAX_NOTIFICATIONS = 400;
export const MAX_EVENTS = 2200;
export const MAX_CAUSAL_DEPTH = 6;
export const PRESIDENTIAL_ATTENTION_BASE = 100;
